module.exports = __webpack_public_path__ + "static/media/Advance programming.a5a43c5c.png";